import { Card, CardContent, CardHeader, Stack, useTheme } from '@mui/material'
import { SwitchField, TextField } from 'src/Libs/inputs/formik'
import React, { useEffect, useMemo } from 'react'
import { useField } from 'formik'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 * Empty fallback function used as a callback for an optional functional property
 * @param _
 */
const onChangeFallback = (_: boolean): void => {
  //
}

interface Props {
  title: string
  name: string
  onChange?: (dirty: boolean) => void
  hasWritingRights?: boolean
}

const IdlePeriodFieldCard: React.VFC<Props> = ({ title, name, onChange = onChangeFallback, hasWritingRights = true }) => {
  const { palette } = useTheme()
  const { t } = useCustomTranslation()
  const activeFieldName = `${name}.isActive`
  const startFieldName = `${name}.start`
  const endFieldName = `${name}.end`
  const [activeField, activeFieldMeta] = useField(activeFieldName)
  const [startField, startFieldMeta] = useField(activeFieldName)
  const [endField, endFieldMeta] = useField(activeFieldName)
  const isPeriodDisabled = useMemo<boolean>(() => !activeField.value, [activeField.value])

  useEffect(() => {
    const isDirty =
      activeField.value !== activeFieldMeta.initialValue ||
      startField.value !== startFieldMeta.initialValue ||
      endField.value !== endFieldMeta.initialValue
    onChange(isDirty)
  }, [
    activeField.value,
    activeFieldMeta.initialValue,
    startField.value,
    startFieldMeta.initialValue,
    endField.value,
    endFieldMeta.initialValue,
    onChange,
  ])

  return (
    <Card sx={{ backgroundColor: palette.grey.grey07 }} elevation={0}>
      <CardHeader title={title} action={<SwitchField name={activeFieldName} disabled={!hasWritingRights} />} />
      <CardContent>
        <Stack direction="row" spacing={2}>
          <TextField
            label={t('common.from')}
            type="time"
            name={startFieldName}
            InputLabelProps={{ shrink: true }}
            disabled={isPeriodDisabled || !hasWritingRights}
          />

          <TextField
            label={t('common.until')}
            type="time"
            name={endFieldName}
            InputLabelProps={{ shrink: true }}
            disabled={isPeriodDisabled || !hasWritingRights}
          />
        </Stack>
      </CardContent>
    </Card>
  )
}

export default IdlePeriodFieldCard
